<template>
  <div style="display: flex; height: 100%; width: 100%">
    <el-dialog
      :title="form.id ? '编辑角色' : '新增角色'"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="dialogBeforeClose"
    >
      <el-form :model="form" :rules="rules" label-width="80px" ref="formRef">
        <el-form-item prop="code" label="角色编码">
          <el-input v-model="form.code" placeholder="请输入角色编码"></el-input>
        </el-form-item>
        <el-form-item prop="name" label="角色名称">
          <el-input v-model="form.name" placeholder="请输入角色名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogBeforeClose" size="medium">取 消</el-button>
        <el-button type="primary" @click="addRoleSubmit" size="medium"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <div class="role-left">
      <div class="filter">
        <div style="position: relative; gap: 12px" class="center">
          <el-select
            v-model="roleVal"
            filterable
            clearable
            placeholder="搜索角色"
            @change="handleRoleSelect"
            style="flex: 1"
          >
            <el-option
              v-for="group in roleList"
              :key="group.id"
              :label="group.name"
              :value="group.id"
            >
            </el-option>
          </el-select>

          <svg-icon
            icon-class="groupAdd"
            style="font-size: 24px; cursor: pointer"
            @click="addRoles"
          ></svg-icon>
          <i class="el-icon-search"></i>
        </div>
      </div>

      <div class="option">
        <div
          v-for="item in roleList"
          :key="item.id"
          class="option-item between"
          :class="{ active: item.id === activeRole.id }"
          @click="changeRole(item)"
        >
          <div>{{ item.name }}</div>

          <el-dropdown class="adminBtn" @command="handleCommand(item, $event)">
            <i style="font-size: 16px" class="el-icon-more"></i>
            <el-dropdown-menu slot="dropdown" :append-to-body="false">
              <el-dropdown-item command="update">重命名</el-dropdown-item>
              <el-dropdown-item command="del">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="role-right">
      <div
        style="
          position: absolute;
          top: 12px;
          right: 20px;
          width: 80px;
          height: 32px;
          background: #107fff;
          border-radius: 4px 4px 4px 4px;
          font-size: 14px;
          color: #ffffff;
          line-height: 16px;
          cursor: pointer;
          z-index: 2;
        "
        class="center"
        @click="submit"
        v-show="activeName === 'role'"
      >
        保存
      </div>
      <el-tabs v-model="activeName" @tab-click="tabClick" style="height: 100%">
        <el-tab-pane label="角色成员管理" name="user">
          <div class="buttons">
            <div></div>
            <div>
              <el-button type="primary" icon="el-icon-plus" @click="showPicker"
                >添加成员</el-button
              >

              <org-picker
                type="user"
                :multiple="true"
                ref="orgPicker"
                :selected="pickerSelected"
                @ok="selected"
              />
            </div>
          </div>
          <el-table
            :data="userList"
            :header-cell-style="headerCellStyle"
            style="width: 100%"
          >
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="电话"></el-table-column>
            <el-table-column prop="position" label="职位"></el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-popconfirm
                  confirm-button-text="确认"
                  cancel-button-text="取消"
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定删除该人员角色吗？"
                  @confirm="handleDeleteUser(scope.$index)"
                >
                  <el-button
                    type="text"
                    slot="reference"
                    style="color: #ff4f4f !important"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane
          label="角色权限设置"
          name="role"
          v-if="activeRole.code !== 'admin'"
        >
          <div>
            <el-select
              v-model="moduleVal"
              filterable
              clearable
              placeholder="请输入应用"
              @change="handleModuleSelect"
              style="width: 160px"
            >
              <el-option
                v-for="module in moduleList"
                :key="module.id"
                :label="module.name"
                :value="module.id"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="formVal"
              placeholder=""
              @input="handleSearch"
              style="width: 160px; margin-left: 17px"
            ></el-input>
          </div>
          <div
            style="
              width: 100%;
              height: 85%;
              display: flex;
              margin-top: 14px;
              min-height: 500px;
              border: 1px solid #ebeef5;
            "
          >
            <div class="role-right-tree">
              <div
                style="
                  font-weight: 500;
                  font-size: 14px;
                  color: #4e5969;
                  height: 48px;
                  line-height: 48px;
                  background: #f5f7fa;
                "
                class="center"
              >
                分类
              </div>
              <div
                style="
                  height: calc(100% - 48px);
                  overflow-y: auto;
                  padding: 14px 0;
                "
              >
                <el-tree
                  :data="data"
                  show-checkbox
                  node-key="id"
                  :props="{
                    children: 'items',
                    label: 'formName',
                  }"
                  @node-click="handleNodeClick"
                  @check-change="handleCheckChange"
                  :render-after-expand="false"
                  ref="treeRefs"
                  default-expand-all
                  :filter-node-method="filterNode"
                >
                  <div class="custom-tree-node" slot-scope="{ node, data }">
                    <span
                      style="font-size: 14px; color: #1d2129; line-height: 18px"
                      class="center"
                    >
                      <span v-show="node.level === 1">【</span>
                      <svg-icon
                        :icon-class="data.pcLogo + ''"
                        style="font-size: 20px; margin-right: 10px"
                        v-show="node.level !== 1"
                        :style="{ color: pcColors[data.bgColor || 0] }"
                      ></svg-icon>
                      <span>{{ node.label }}</span>
                      <span v-show="node.level === 1">】</span>
                    </span>
                  </div>
                </el-tree>
              </div>
            </div>
            <div class="role-right-form">
              <div
                style="
                  font-weight: 500;
                  font-size: 14px;
                  color: #4e5969;
                  height: 48px;
                  line-height: 48px;
                  background: #f5f7fa;
                "
                class="center"
              >
                权限设置
              </div>

              <div style="padding: 20px 40px">
                <span
                  style="font-size: 14px; color: #1d2129; line-height: 18px"
                >
                  表单操作权限
                </span>
                <div style="margin-top: 12px">
                  <div
                    style="
                      border-left: 1px solid #cfcfcf;
                      padding: 14px 22px;
                      padding-right: 0;
                    "
                  >
                    <el-checkbox
                      :indeterminate="btnIsIndeterminate"
                      v-model="checkBtnAll"
                      @change="handleCheckBtnAllChange"
                      >全选</el-checkbox
                    >
                    <div style="margin: 10px 0"></div>
                    <el-checkbox-group
                      v-model="checkedBtns"
                      @change="handleCheckedBtnChange"
                    >
                      <el-checkbox
                        v-for="btn in btns"
                        :label="btn.key"
                        :key="btn.key"
                        >{{ btn.name }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                </div>
              </div>

              <div style="padding: 0 40px">
                <span
                  style="font-size: 14px; color: #1d2129; line-height: 18px"
                >
                  表单数据权限
                </span>
                <div style="margin-top: 12px">
                  <div
                    style="
                      border-left: 1px solid #cfcfcf;
                      padding: 11px 22px;
                      padding-right: 0;
                      padding-top: 9px;
                    "
                  >
                    <el-radio-group
                      v-model="formRadio"
                      @change="handleFormRadioChange"
                    >
                      <el-radio label="ME">本人</el-radio>
                      <el-radio label="DEPT">部门</el-radio>
                      <el-radio label="ALL">全部</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  getAllRole,
  getFormsByRoleId,
  updateRoleForms,
  updateOrAddRole,
  getUsersByRoleId,
  updateRoleUsers,
} from "@/api/setProcess";
import { getFormGroups } from "@/api/design";
import { headerCellStyle } from "@/utils/CustomUtil.js";
import OrgPicker from "@/components/common/OrgPicker";
export default {
  components: { OrgPicker },
  data() {
    return {
      pickerSelected: [],
      roleVal: "",
      activeRole: {},
      activeName: "role",
      roleList: [],
      moduleVal: "",
      formVal: "",
      formList: [],
      data: [],
      pcColors: ["#FA8118", "#56CA56", "#0AB1F7", "#107FFF", "#686FFF"],
      btns: [
        {
          name: "提交",
          key: "SUBMIT",
        },
        {
          name: "导入",
          key: "IMPORT",
        },
        {
          name: "导出",
          key: "EXPORT",
        },
        {
          name: "打印",
          key: "PRINT",
        },
        {
          name: "删除",
          key: "DELETE",
        },
      ],
      checkBtnAll: false,
      checkedBtns: [],
      btnIsIndeterminate: false,
      formRadio: "ME",
      formRoles: [],
      checkedKeys: [],
      dialogVisible: false,
      form: {
        name: "",
        code: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入角色名称", trigger: ["change"] },
        ],
        code: [
          { required: true, message: "请输入角色编码", trigger: ["change"] },
        ],
      },
      userList: [],
      multipleSelection: [],
      isChange: false,
    };
  },
  created() {
    this.getRoleData();
    if (this.moduleList.length) {
      this.handleModuleSelect(this.moduleList[0].id);
    }
  },
  computed: {
    moduleList() {
      return this.$store.state.formData.moduleList;
    },
  },

  methods: {
    async submitUser() {
      const list = this.userList.map((item) => {
        return {
          ...item,
          id: null,
          roleId: this.activeRole.id,
          userId: item.id,
        };
      });
      await updateRoleUsers(list);
      this.$message.success("保存成功");
    },
    handleDeleteUser(index) {
      this.userList.splice(index, 1);
      this.submitUser();
    },
    selected(values) {
      this.userList.push(...values);
      this.submitUser();
    },
    showPicker() {
      this.$refs.orgPicker.show();
    },
    headerCellStyle,

    dialogBeforeClose() {
      this.form.name = "";
      this.form.code = "";
      this.dialogVisible = false;
    },
    async addRoleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          await updateOrAddRole(this.form);
          this.$message({
            type: "success",
            message: this.form.id
              ? `编辑${this.form.name}角色成功`
              : `添加${this.form.name}角色成功`,
          });
          this.getRoleData();
          this.dialogBeforeClose();
        } else {
          return false;
        }
      });
    },
    addRoles(item) {
      if (item) {
        this.form = {
          ...item,
        };
      }
      this.dialogVisible = true;
    },
    handleCommand(item, command) {
      if (command === "update") {
        this.addRoles(item);
      }
    },
    handleSearch(val) {
      this.$refs.treeRefs.filter(val);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.formName.indexOf(value) !== -1;
    },
    async submit() {
      if (this.activeName === "role") {
        const list = this.formRoles.map((item) => {
          return {
            ...item,
            id: null,
          };
        });
        await updateRoleForms(list);
        this.$message.success("保存成功");
      }
    },
    handleCheckChange(val, checked) {
      if (val.name) return;
      const isRoles = this.formRoles.find((item) => item.formId === val.id);
      if (isRoles) {
        isRoles.btn = checked
          ? this.checkedBtns.length
            ? this.checkedBtns.join(",")
            : this.btns.map((item) => item.key).join(",")
          : "";
        isRoles.dataType = isRoles.dataType || "ME";
      } else {
        if (checked) {
          this.formRoles.push({
            formId: val.id,
            btn: this.btns.map((item) => item.key).join(","),
            dataType: "ALL",
            roleId: this.activeRole.id,
          });
        }
      }
      if (!this.isChange) {
        this.$refs.treeRefs.setCurrentKey(val.id);
        this.handleNodeClick(val);
      }
    },
    handleNodeClick(data, node) {
      if (node && node.level === 1) return;
      this.activeForm = { ...data };
      this.checkedBtns = [];
      this.formRadio = "ME";
      const isRoles = this.formRoles.find((item) => item.formId === data.id);
      if (isRoles) {
        this.checkedBtns = isRoles.btn ? isRoles.btn.split(",") : [];
        this.formRadio = isRoles.dataType;
      } else {
        this.checkedBtns = [];
        this.formRadio = "ME";
      }
      let checkedCount = this.checkedBtns.length;
      this.checkBtnAll = checkedCount === this.btns.length;
      this.btnIsIndeterminate =
        checkedCount > 0 && checkedCount < this.btns.length;
    },
    handleCheckBtnAllChange(val) {
      this.checkedBtns = val ? this.btns.map((item) => item.key) : [];
      this.btnIsIndeterminate = false;
      this.handleCheckedBtnChange(this.checkedBtns);
    },
    handleCheckedBtnChange(value) {
      let checkedCount = value.length;
      this.checkBtnAll = checkedCount === this.btns.length;
      this.btnIsIndeterminate =
        checkedCount > 0 && checkedCount < this.btns.length;

      const isRoles = this.formRoles.find(
        (item) => item.formId === this.activeForm.id
      );
      if (isRoles) {
        isRoles.btn = value.join(",");
      }
      this.setCheckedKeys();
    },
    handleFormRadioChange(val) {
      const isRoles = this.formRoles.find(
        (item) => item.formId === this.activeForm.id
      );
      if (isRoles) {
        isRoles.dataType = val;
      }
    },
    setCheckedKeys() {
      if (this.checkedBtns.length === 0) {
        this.checkedKeys = this.checkedKeys.filter(
          (item) => item !== this.activeForm.id
        );
      } else {
        this.checkedKeys.push(this.activeForm.id);
      }
      this.$refs.treeRefs.setCheckedKeys(this.checkedKeys);
    },

    changeRole(item) {
      this.activeRole = { ...item };
      if (this.activeRole.code === "admin") {
        this.activeName = "user";
        this.getUsersByRole();
        return;
      }
      if (this.activeName === "role") {
        this.getFormsByRole();
      } else {
        this.getUsersByRole();
      }
    },
    async getRoleData() {
      const res = await getAllRole();
      this.roleList = res.data;
      if (!this.activeRole.id) {
        this.changeRole(this.roleList[0]);
      }
    },
    tabClick(tab) {
      // console.log(tab, event);
      if (tab.name === "role") {
        this.getFormsByRole();
      } else {
        this.getUsersByRole();
      }
    },
    async getUsersByRole() {
      const res = await getUsersByRoleId(this.activeRole.id);
      this.userList = res.data;
    },
    async getFormsByRole() {
      const res = await getFormsByRoleId(this.activeRole.id);
      this.isChange = true;
      this.formRoles = [...res.data];
      this.$refs.treeRefs.setCheckedKeys([]);
      this.checkedKeys = [];
      this.formRoles.forEach((item) => {
        if (item.btn) {
          const btnLength = item.btn.split(",").length;
          if (btnLength) {
            this.checkedKeys.push(item.formId);
          }
        }
      });
      this.$refs.treeRefs.setCheckedKeys(this.checkedKeys);
      if (this.isChange) {
        this.handleNodeClick(this.data[0].items[0]);
        this.$refs.treeRefs.setCurrentKey(this.data[0].items[0].id);
        this.isChange = false;
      }
    },

    handleRoleSelect(val) {
      if (!val) return;
      const item = this.roleList.find((item) => item.id === val);
      this.changeRole(item);
    },
    async handleModuleSelect(val) {
      if (!val) return;
      this.moduleVal = val;
      const { data } = await getFormGroups(val);
      data.forEach((item) => {
        item.formName = item.name;
      });
      this.data = data.filter((item) => item.items);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-checkbox__input {
  line-height: unset;
}
/deep/.el-checkbox__inner {
  width: 16px;
  height: 16px;
}
/deep/.el-tree-node__expand-icon {
  transform: translateX(30px);
  &.expanded {
    transform: translateX(30px) rotate(90deg);
  }
}
/deep/.el-tree-node__content:hover,
.el-upload-list__item:hover {
  background: #ecf5ff;
}
/deep/.el-tree-node .el-checkbox {
  line-height: 18px;
  transform: translateX(-10px);
}
/deep/.el-tree-node__content {
  height: 36px;
  padding-left: 4px !important;
}
/deep/.el-input__inner {
  border-radius: 4px;
  height: 32px;
  line-height: 32px;
  &::placeholder {
    font-size: 14px;
    font-weight: 300 !important;
  }
}
/deep/.el-input__icon {
  line-height: 32px;
}

.role-left {
  width: 264px;
  border-right: 1px solid #ebecee;
  padding: 20px;
  position: relative;

  .filter {
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
    width: 100%;
  }
  /deep/.el-input__inner {
    padding-left: 28px;
  }

  .el-icon-search {
    position: absolute;
    z-index: 2;
    left: 11px;
    top: 11px;
    font-size: 12px;
    color: #c5c8d0;
  }

  .option {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 18px;
    .option-item {
      width: 224px;
      height: 36px;
      border-radius: 4px 4px 4px 4px;
      transition: all 0.3s ease-in-out;
      padding: 10px;
      font-size: 14px;
      color: #1d2129;
      line-height: 16px;
      cursor: pointer;

      &:hover {
        background: #eef1f6;
      }
      &.active {
        background: #eef1f6;
      }
      /deep/.el-dropdown-menu {
        width: 90px;
      }
      .adminBtn {
        opacity: 0;
        display: flex;
        align-items: center;
        width: fit-content;
      }
      &:hover {
        .adminBtn {
          opacity: 1;
        }
      }
    }
  }
}
.role-right {
  // width: 100%;
  width: calc(100% - 264px);
  padding: 0 20px;
  position: relative;
  /deep/.el-tabs__item {
    height: 52px;
    line-height: 52px;
    color: #838892;
    font-weight: normal;
    &.is-active {
      color: #107fff;
    }
    &:hover {
      color: #107fff;
    }
  }
  /deep/.el-tabs__nav-wrap::after {
    background: #ebecee;
    height: 1px;
  }
}

.role-right-tree {
  width: 220px;
  border-right: 1px solid #ebeef5;
}

.role-right-form {
  flex: 1;
  width: 100%;
}

/deep/.el-tabs__content {
  height: calc(100% - 52px - 15px);
}

/deep/.el-tab-pane {
  height: 100%;
}

/deep/.is-current {
  background: #ecf5ff;
}

/deep/.el-table .el-table__cell {
  padding: 0;
}

.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  .el-button {
    width: 96px !important;
    height: 32px !important;
    font-size: 14px;
    border-color: transparent !important;
    line-height: 32px !important;
    text-align: center;
    padding: 0;
  }
}
</style>